<template>
  <v-dialog v-model="dialog">
    <v-card>
      <v-card-title class="headline grey lighten-2">
        SMSコマンド送信 (FC2000)
      </v-card-title>
      <v-card-text>
        <div style="width: 90%; margin: 20px; text-align: left">
          SMSコマンドをスマートフォンのSMSアプリを使って送信することによりカメラの操作が可能です。次の画面でそのままメッセージを送信してください。
        </div>
        <v-divider></v-divider>
        <div style="margin: 20px">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*500#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn color="error" elevation="2" x-large>即時撮影送信</v-btn>
          </a>
        </div>
        <v-divider></v-divider>
        <div style="margin: 20px; text-align: left">モード変更</div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*C#A1#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>静止画モード</v-btn>
          </a>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*C#A2#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>動画モード</v-btn>
          </a>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*C#A3#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>静止画+動画モード</v-btn>
          </a>
        </div>
        <div style="margin: 20px; text-align: left">センサー感度変更</div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*T#A0#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>センサー感度 【高】 設定</v-btn>
          </a>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*T#A1#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>センサー感度 【中】 設定</v-btn>
          </a>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*T#A2#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>センサー感度 【低】 設定</v-btn>
          </a>
        </div>
        <div style="margin: 10px; margin-bottom: 20px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*T#A3#'
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>センサー感度 【OFF】 設定</v-btn>
          </a>
        </div>
        <div style="margin: 20px; text-align: left">タイムラプス設定変更</div>
        <div style="margin: 10px; margin-bottom: 20px; text-align: left">
          <v-select
            v-model="timelapseItem"
            :items="timelapseItems"
            item-text="text"
            item-value="time"
            label="タイムラプス時間設定"
            dense
            outlined
            return-object
          ></v-select>
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              timelapseItem.time
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>タイムラプス設定</v-btn>
          </a>
        </div>
        <div style="margin: 20px; text-align: left">画像サイズ変更</div>
        <div style="margin: 10px; margin-bottom: 20px; text-align: left">
          <v-select
            v-model="imageResoItem"
            :items="imageResoItems"
            item-text="text"
            item-value="size"
            label="画像サイズ"
            dense
            outlined
            return-object
          ></v-select>
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              imageResoItem.size
            )}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>画像サイズ設定</v-btn>
          </a>
        </div>
        <v-divider></v-divider>
        <div style="margin: 20px; text-align: left">
          送信先メールアドレス追加 / 削除
        </div>
        <div style="margin: 10px; text-align: left; width: 80%">
          メールアドレス: <v-text-field outlined v-model="email"></v-text-field>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*W#H'
            )}${email}${encodeURIComponent('#')}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>送信先メールアドレス 追加</v-btn>
          </a>
        </div>
        <div style="margin: 10px; margin-bottom: 20px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*W#I'
            )}${email}${encodeURIComponent('#')}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>送信先メールアドレス 削除</v-btn>
          </a>
        </div>
        <v-divider></v-divider>
        <div style="margin: 20px; text-align: left">
          SMS送信元電話番号追加 / 削除
        </div>
        <div style="margin: 10px; text-align: left; width: 80%">
          電話番号: <v-text-field outlined v-model="phone"></v-text-field>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*W#F'
            )}${phone}${encodeURIComponent('#')}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>SMS送信元電話番号 追加</v-btn>
          </a>
        </div>
        <div style="margin: 10px; text-align: left">
          <a
            :href="`sms:${phoneNumber}${agentPostfix}body=${encodeURIComponent(
              '*W#G'
            )}${phone}${encodeURIComponent('#')}`"
            style="text-decoration: none; color: #000"
          >
            <v-btn>SMS送信元電話番号 削除</v-btn>
          </a>
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" text @click="closeDialog"> 閉じる </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "SmsDialog",
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    phoneNumber: {
      type: String,
      required: true,
    },
    agentPostfix: {
      type: String,
      required: true,
    },
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  data() {
    return {
      timelapseItem: { text: "24時間", time: "*T#DF#" },
      timelapseItems: [
        { text: "24時間", time: "*T#DF#" },
        { text: "12時間", time: "*T#DE#" },
        { text: "8時間", time: "*T#DD#" },
        { text: "6時間", time: "*T#DC#" },
        { text: "4時間", time: "*T#DB#" },
        { text: "3時間", time: "*T#DA#" },
        { text: "2時間", time: "*T#D9#" },
        { text: "1時間", time: "*T#D8#" },
        { text: "30分", time: "*T#D7#" },
        { text: "10分", time: "*T#D6#" },
        { text: "5分", time: "*T#D5#" },
        { text: "3分", time: "*T#D4#" },
        { text: "1分", time: "*T#D3#" },
        { text: "30秒", time: "*T#D2#" },
        { text: "オフ", time: "*T#D1#" },
      ],
      imageResoItem: { text: "500万画素", size: "*C#E1#" },
      imageResoItems: [
        { text: "500万画素", size: "*C#E1#" },
        { text: "800万画素", size: "*C#E2#" },
        { text: "1000万画素", size: "*C#E3#" },
        { text: "1200万画素", size: "*C#E4#" },
        { text: "2400万画素", size: "*C#E5#" },
      ],
      email: "",
      phone: "",
    };
  },
  methods: {
    closeDialog() {
      this.$emit("input", false);
    },
  },
};
</script>
